'use client'

import React, { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'

import { selectIsSmilesSession } from '@/src/redux/slices/smilesSlice'
import { useAppSelector } from '@/src/redux/store'
import { isSmilesEnabledForBrand } from '@/src/utils/smiles/isSmilesEnabledForBrand'

import SmilesBanner from './smilesBanner'

const SmilesBannerWrapper = React.memo(() => {
    const t = useTranslations('smiles')
    const isSmilesSession = useAppSelector(selectIsSmilesSession)
    // isMounted guard defers the client-only gate to after mount, avoiding a hydration mismatch.
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    if (!isMounted || !isSmilesSession || !isSmilesEnabledForBrand()) return null

    return <SmilesBanner message={t('bannerText')} />
})

SmilesBannerWrapper.displayName = 'SmilesBannerWrapper'

export { SmilesBannerWrapper }
export default SmilesBannerWrapper
